<template>
  <div>
    <iframe
      id="iframeSofaScore"
      width="100%"
      height="154"
      frameborder="0"
      scrolling="no"
      :src="
        'https://widgets.sofascore.com/embed/attackMomentum?id=' +
        $route.params.idEvento +
        '&widgetBackground=White'
      "
    ></iframe>
  </div>
</template>

<script>
export default {
  name: "Sofascore",
  components: {},
  props: {},
  methods: {},
};
</script>

<style scoped>
#iframeSofaScore {
  width: 100%;
  border: none;
  position: relative;
  top: -44px;
  height: 335px;
}
</style>